import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal';
import FetchApi from '../../../customhooks/functionFetchApi';
import Swal from 'sweetalert2';
import ViewNotetimelage from '../viewNotetimelage';

const MAX_DETAILNOTE = 1000;

// ฟอร์มบันทึกเหตุผลล่าช้า + ประวัติการบันทึกของเอกสารนี้ (ViewNotetimelage ใช้ร่วมกับ tab สาเหตุล่าช้า)
function Formnotetimelage({ journalId, journalcode, handleShow }) {
    const FetchApis = new FetchApi();
    const emCode = sessionStorage.getItem('EmCode');
    const userName = sessionStorage.getItem('UserName');

    const [detailnote, setDetailnote] = useState("");
    const [saving, setSaving] = useState(false);

    function onSave() {
        if (detailnote.trim() == "") {
            Swal.fire({
                title: "แจ้งเตือน",
                text: "กรุณาระบุเหตุผลล่าช้า",
                icon: "warning",
                confirmButtonText: "ตกลง",
                confirmButtonColor: "#3085d6"
            });
            return;
        }

        // ต้องยืนยันก่อนบันทึกทุกครั้ง
        Swal.fire({
            title: "บันทึกล่าช้า",
            text: "คุณแน่ใจที่จะบันทึกเหตุผลล่าช้า ใช่หรือไม่ ! ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ใช่",
            cancelButtonText: 'ยกเลิก'
        }).then((result) => {
            if (result.isConfirmed) {
                setSaving(true)
                var dataobject = {
                    journalId: journalId,
                    emcode: emCode,
                    detailnote: detailnote.trim()
                }
                FetchApis.FethcPost(`/notetimelage/createnotetimelage`, dataobject).then((res) => {
                    setSaving(false)
                    if (res && res.status == 200) {
                        Swal.fire({
                            title: "บันทึกล่าช้า",
                            text: "บันทึกเหตุผลล่าช้าเรียบร้อยแล้ว",
                            icon: "success"
                        });
                        setDetailnote("")
                        handleShow(false)
                    } else {
                        Swal.fire({
                            title: "บันทึกไม่สำเร็จ",
                            text: res && res.message ? res.message : "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
                            icon: "error"
                        });
                    }
                })
            }
        });
    }

    return <div>
        <div className='row-page' style={{ marginBottom: 10 }}>
            <div style={{ marginRight: 20 }}><b>เอกสาร :</b> {journalcode}</div>
            <div><b>ผู้บันทึก :</b> {userName}</div>
        </div>
        <div style={{ margin: '5px 0' }}><b>เหตุผลล่าช้า</b></div>
        <textarea name='DetailNote' style={{ width: '100%', height: 100 }} maxLength={MAX_DETAILNOTE}
            value={detailnote}
            onChange={(e) => setDetailnote(e.target.value)} />
        <div className='row-between-page'>
            <div style={{ fontSize: 12, color: 'gray' }}>{detailnote.length} / {MAX_DETAILNOTE}</div>
            <div className='end-flex-row'>
                <Button size='sm' style={{ marginRight: 10 }} disabled={saving} onClick={() => onSave()}>บันทึก</Button>
                <Button size='sm' variant="warning" disabled={saving} onClick={() => handleShow(false)}>ยกเลิก</Button>
            </div>
        </div>

        <hr></hr>
        <div style={{ marginBottom: 5 }}><b>ประวัติการบันทึกล่าช้า</b></div>
        <ViewNotetimelage jourId={journalId} />
    </div>
}

const Journalnotetimelage = ({ journalId, journalcode }) => {
    const [show, setShow] = useState(false);

    function handleShow(value) {
        setShow(value);
    }

    return (
        <div>
            <Button size='sm' variant="secondary" style={{ marginRight: 10 }}
                onClick={() => handleShow(true)}>บันทึกล่าช้า</Button>

            <Modal show={show} size="lg" onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>บันทึกเหตุผลล่าช้า</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formnotetimelage journalId={journalId} journalcode={journalcode} handleShow={handleShow} />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Journalnotetimelage
